import request from "@/services/request"

const api = {
        unionid: code => `/user/get_user?unionid=${code}`,
        improve_rate: code => `/setting/chang_improve_rate?rate=${code}`,
        order: '/user/orders',
        info: '/user/recharges',
        user: 'setting/get_all_user',
        allorder: '/setting/all_order',
        recharge: '/setting/user_recharge',
        reduce: '/setting/user_discount',
        allServiceList: '/setting/list',
        redefine: '/setting/redefine',
        wxPay: '/user/wxpays',
        allWxPay: '/setting/all_wx_order',
        profit: '/setting/profit',
        wxMiniLink :'/user/link',
        wxMiniHttpLink :'/user/http_link',
    }
    /**
     * 获取用户信息
     * @param {*} param0
     */
export function getUserInfo(params) {
    return request({
        url: api.unionid(params),
        method: "get",
    })
}

export function getWxMiniLink(params) {
    return request({
        url: api.wxMiniLink,
        method: "get",
        params:params,
    })
}
export function getWxMiniHttpLink(params) {
    return request({
        url: api.wxMiniHttpLink,
        method: "get",
        params:params,
    })
}

/**
 * 获取用户列表信息
 * @param {*} param0
 */
export function getUserList(params) {
    return request({
        url: api.user,
        method: "get",
        params
    })
}

/**
 * 获取充值列表信息
 * @param {*} param0
 */
export function getAllOrder(params) {
    return request({
        url: api.allorder,
        method: "get",
        params
    })
}

/**
 * 获取订单信息
 * @param {*} param0
 */
export function getOrderList(params) {
    return request({
        url: api.order,
        method: "get",
        params
    })
}

/**
 * 代理商-可编辑的服务项列表
 * @param {*} param0
 */
export function getAllService(params) {
    return request({
        url: api.allServiceList,
        method: "get",
        params
    })
}
/**
 * 代理商-编辑操作
 * @param {*} param0
 */
export function getRedefine(params) {
    return request({
        url: api.redefine,
        method: "get",
        params
    })
}
/**
 * 获取充值信息
 * @param {*} param0
 */
export function getRechargeList(params) {
    return request({
        url: api.info,
        method: "get",
        params
    })
}
/**
 * 获取微信充值信息
 * @param {*} param0
 */
export function getUserWXpayList(params) {
    return request({
        url: api.wxPay,
        method: "get",
        params
    })
}

export function getAllWXPayList(params) {
    return request({
        url: api.allWxPay,
        method: "get",
        params
    })
}

/**
 *  用户充值操作
 * @param {*} param0
 */
export function getRechargeOperate(params) {
    return request({
        url: api.recharge,
        method: "get",
        params
    })
}

/**
 *  用户折扣操作
 * @param {*} param0
 */
export function getReduceOperate(params) {
    return request({
        url: api.reduce,
        method: "get",
        params
    })
}


/**
 * 代理商盈利数据
 * @param {*} param0
 */
export function getProfit(params) {
    return request({
        url: api.profit,
        method: "get",
        params
    })
}

export function changImproveRate(params) {
    return request({
        url: api.improve_rate(params),
        method: "get",
    })
}